import { configureStore } from '@reduxjs/toolkit';
import { setupListeners } from '@reduxjs/toolkit/query';

import { driessenstoffenApi } from './service';
import { getValuesFromCache } from './cache';

const store = configureStore({
  reducer: {
    [driessenstoffenApi.reducerPath]: driessenstoffenApi.reducer,
  },
  middleware: (getDefaultMiddleware) => getDefaultMiddleware()
    .concat(driessenstoffenApi.middleware),
});

setupListeners(store.dispatch);

getValuesFromCache().forEach(({ endpoint, params, data }) => {
  store.dispatch(driessenstoffenApi.util.upsertQueryData(endpoint, params, data));
});

export default store;
